<template>
  <el-dialog
    top="0"
    :visible.sync="isShow"
    :before-close="cancel"
    :show-close="ifAddFlag"
    :close-on-click-modal="ifAddFlag"
    :close-on-press-escape="ifAddFlag"
    custom-class="add-course-dialog"
    id="addCourseDialog"
  >
    <div slot="title" class="dialog-title">
      <div class="title" v-if="!isAddCoursesAgain">
        {{
          isAddCoursesAgain
            ? "您选择的课程服务已到期或被关闭，请您重新选择"
            : "挑选常用课程"
        }}
      </div>
    </div>
    <div class="dialog-content">
      <div class="option" v-if="stagesProp.length">
        <span class="name">学段：</span>
        <div class="props">
          <span
            :class="['item', { on: currentStage === stage.id }]"
            v-for="stage in stagesProp"
            :key="stage.id"
            data-io-click="tracker"  @click="changeStage(stage)"
            >{{ stage.name }}</span
          >
        </div>
      </div>
      <div class="option" v-if="subjects.length">
        <span class="name">学科：</span>
        <div class="props">
          <el-checkbox-group v-model="checkCourseList">
            <el-checkbox
              class="item"
              v-for="subject in subjects"
              :key="subject.subjectId"
              :label="subject.courseId"
              @change="changeSubject(subject)"
              style="margin: 15px 2px 5px"
            >
              {{ subject.subjectName }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="tool" v-if="subjects.length && stagesProp.length">
        <span class="btn" data-io-click="tracker"  @click="cancel" v-if="ifAddFlag">取消</span>
        <span
          :class="[
            'btn sure',
            { on: !isEqualCourseData && this.checkCourseList.length !== 0 },
          ]"
          data-io-click="tracker"  @click="submit"
          >确定</span
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import api from "@/assets/js/service/api";
import tracker from "@/assets/js/statistics/xkw.tracker";
import request from "@/utils/request";
import { Message } from "element-ui";
import { mapMutations, mapState } from "vuex";
import course from "@/assets/js/mixin/course";
import getUserTextbooks from "@/assets/js/mixin/getUserTextbook";
import tongji from "@/assets/js/mixin/tongji";
// 在导入部分添加 Element 组件
import { CheckboxGroup, Checkbox } from "element-ui";

export default {
  inject: ["textbook"],
  components: {
    "el-checkbox-group": CheckboxGroup,
    "el-checkbox": Checkbox,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    stagesProp: {
      type: Array,
      default() {
        return [];
      },
    },
    triggerType: {
      type: String,
      default: "主动",
    },
    // 是否是重新添加课程显示
    isAddCoursesAgain: {
      type: Boolean,
      default: false,
    },
    isSchoolBased: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [course],
  watch: {
    currentCourse(val) {
      if (val) {
        this.currentStage = val.stageId;
      }
    },
    async stagesProp(val) {
      console.log("val----", val);
      this.checkCourseList = [];
      this.checkCourseListCopy = [];
      val.forEach((i) => {
        i.courseList.forEach((j) => {
          if (j.isUse) {
            this.checkCourseList.push(j.courseId);
            this.checkCourseListCopy.push(j.courseId);
          }
        });
      });
      // 如果
      if (val && val.length > 0) {
        // console.log("当前的学段---stagesProp", this.currentStage);
        if (!this.currentStage || this.isAddCoursesAgain) {
          if (this.triggerType === "被动") {
            // console.log("获取用户画像");
            let data = await request.get(api.base.getUserImage);
            let { mdmStageid, mdmSubjectid } = data.result;
            // console.log("data", data);
            if (!mdmStageid && !mdmSubjectid) {
              this.currentStage = val[0].id;
            } else {
              this.currentStage = mdmStageid;
              this.currentSubject = !this.isAddCoursesAgain ? mdmSubjectid : "";
            }
          } else {
            this.currentStage = val[0].id;
          }
        }
      }
    },
  },
  computed: {
    ...mapState({
      // 用户当前选择的课程
      currentCourse: "currentCourse",
      userCourses: "userCourses",
    }),
    isShow: {
      get() {
        return this.isVisible;
      },
      set() {},
    },
    ifAddFlag() {
      // console.log('triggerType',this.triggerType)
      return this.triggerType == "主动";
    },
    subjects: {
      get() {
        const stage = this.stagesProp.find((stage) => {
          return stage.id === this.currentStage;
        });
        // console.log("当前的学段", stage);
        // if (!stage) {
        //   this.currentStage = this.stagesProp && this.stagesProp[0].id;
        // }
        return stage ? stage.courseList : [];
      },
      set() {},
    },
  },
  data() {
    return {
      currentStage: 3,
      currentSubject: "",
      // ifAddFlag: true,
      checkCourseList: [],
      checkCourseListCopy: [],
      isEqualCourseData: true,
      isDeleteCurrentCourse: false,
    };
  },
  mounted() {},
  methods: {
    ...mapMutations({
      setCurrentCourse: "setCurrentCourse",
    }),
    changeStage(stage) {
      if (!stage) return;

      this.currentStage = stage.id;
      this.currentSubject = "";

      // 确保 stage.courseList 存在
      if (stage.courseList) {
        this.subjects = stage.courseList;
      } else {
        this.subjects = [];
      }
    },
    changeSubject(subject) {
      this.isEqualCourseList();
    },
    //判断课程是否发生过变化
    isEqualCourseList() {
      this.isEqualCourseData =
        JSON.stringify(this.checkCourseList.sort()) ===
        JSON.stringify(this.checkCourseListCopy.sort());
    },
    submit() {
      if (this.isEqualCourseData) {
        Message({
          message: "请修改常用课程",
          type: "warning",
          duration: 2 * 1000,
        });
        return false;
      }
      if (this.checkCourseList.length == 0) {
        Message({
          message: "不可删除全部课程，请检查后重试",
          type: "warning",
          duration: 2 * 1000,
        });
        return false;
      }
      // 找出被取消的课程 ID
      const canceledCourseIds = this.checkCourseListCopy.filter(
        (id) => !this.checkCourseList.includes(id)
      );
      //如果本次没有删除课程,则调取修改接口即可
      if (canceledCourseIds.length === 0) {
        this.updateUserCourseListMethod();
        return;
      }
      //是否删除了当前选中的课程了
      this.isDeleteCurrentCourse = canceledCourseIds.includes(
        this.currentCourse.courseId
      );
      //如果存在删除的课程，则需要调取接口，判断是否提示  对应的弹窗
      request
        .postJson(api.work.deleteUserCoursesIsTip, canceledCourseIds)
        .then((result) => {
          //如果需要提示弹窗
          if (result.result.isTip) {
            this.handleDeleteTipDialogVisible(result.result);
          } else {
            //进行批量修改
            this.updateUserCourseListMethod();
          }
        });
    },
    //更新用户的课程列表
    updateUserCourseListMethod() {
      request
        .postJson(api.work.updateUserCourseList, this.checkCourseList)
        .then((data) => {
          if (data.result) {
            Message({
              message: "操作成功",
              type: "success",
              duration: 2 * 1000,
            });
            // 刷新页面的课程列表
            this.getUserCourses().then(() => {
              // 如果删除掉了当前选择的课程，则需要更改 选中的课程为已添加的第一个课程
              if (this.isDeleteCurrentCourse) {
                for (let i = 0; i < this.userCourses.length; i++) {
                  const course = this.userCourses[i].courseList.find(
                    (j) => j.isUse
                  );
                  if (course) {
                    // 重新设置当前课程
                    this.setCurrentCourse(course);
                    this.updateLastUsedCourse(course);
                    // 更新上次使用过的课程
                    localStorage.setItem(
                      `${this.userInfo.userId}-` + "CURRENTCOURSE",
                      JSON.stringify(course)
                    );
                    break;
                  }
                }
              }
              this.cancel();
            });
          } else {
            Message({
              message: "操作失败",
              type: "warning",
              duration: 2 * 1000,
            });
          }
        });
    },
    handleDeleteTipDialogVisible: function (data) {
      this.hideDialog("none");
      this.textbook.deleteTip = data.courses.join(",");
      this.textbook.deleteVisible = true;
      let callback = () => {
        this.textbook.deleteVisible = true;
      };
      this.textbook.noticeParentPageShowMask(true, callback, ".delete-course");
    },
    hideDialog(styleData) {
      //隐藏常用课程的弹窗
      const element = document.getElementById("addCourseDialog");
      element.style.display = styleData;
    },
    cancel() {
      // debugger;
      // console.log("触发关闭事件");
      this.sendTongjiData("关闭");
      this.currentSubject = "";
      this.checkCourseList = [];
      this.checkCourseListCopy = [];
      this.$emit("close");
      // this.isShow = false;
    },
    sendTongjiData(type) {
      let xueduan =
        this.stagesProp.find((item) => item.id === this.currentStage) || null;
      let xueke = xueduan
        ? xueduan.courseList.find(
            (item) => item.subjectId === this.currentSubject
          )
        : "";
      tracker.handleSendTongji({
        $event_name: "set_textbook_course_popup",
        operate_type: type,
        popup_name: "课程设置",
        trigger_type: this.triggerType,
        xueduan: xueduan ? xueduan.name : "",
        xueke: xueke ? xueke.name : "",
        banben: "",
        cebie: "",
      });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
  width: 708px;

  .el-dialog__header {
    padding: 20px 20px 10px 24px;
    height: auto;
    border-bottom: none;
    text-align: center;

    .dialog-title {
      text-align: left;
    }

    .title {
      height: 20px;
      font-size: 20px;
      font-weight: 700;
      color: #333;
      line-height: 20px;
    }

    .el-dialog__headerbtn:hover i {
      color: #1a1a1a;
    }
  }
}

.dialog-content {
  padding: 0px 24px 20px 24px;

  .option {
    position: relative;
    padding-left: 47px;

    .name {
      position: absolute;
      left: 0;
      top: 14px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
      color: #80848b;
    }

    .props {
      .item {
        margin: 15px 6px 5px;
        padding: 0 8px;
        display: inline-block;
        height: 24px;
        line-height: 24px;
        background: #ffffff;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
        // border: 1px solid #fff;
        cursor: pointer;

        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #0057ff;
          border-color: #0057ff;
        }

        ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #1a1a1a;
        }

        &.disable {
          // color: #999;
          // border-color: #eee;
          // background: #eee;
          color: #0057ff;
          position: relative;
          background: #e6f2ff;

          &:hover {
            color: #999;
            border-color: #eee;
            background: #eee;
          }

          img {
            position: absolute;
            width: 14px;
            height: 14px;
            top: -7px;
            right: -7px;
          }
        }

        &.on {
          background: #e6f2ff;
          color: #0057ff;
        }
        &:hover {
          color: #0057ff;
          ::v-deep .el-checkbox__input .el-checkbox__inner {
            border: 1px solid #0057ff;
          }
        }
      }
    }
  }

  .tool {
    margin-top: 30px;
    text-align: center;
    float: right;
    margin-bottom: 20px;

    .btn {
      display: inline-block;
      width: 88px;
      height: 32px;
      line-height: 30px;
      background: #fff;
      border-radius: 8px;
      color: #0057ff;
      cursor: pointer;
      border: 1px solid #0057ff;
      margin-left: 10px;

      &.sure {
        background: #4494ff;
        color: #fff;
        border: none;

        &:hover {
          background: #4494ff;
        }
      }

      &.on {
        background: #0057ff;
        color: #fff;
        border-color: #0057ff;
      }

      &:hover {
        background: #e6f2ff;
      }
    }
  }
}
</style>
